<svg
  width="8"
  height="14"
  viewBox="0 0 8 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1.11791 12.7692L6.8708 6.99994L1.11792 1.23071"
    stroke="#121835"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
